import { TAX_INCLUDED_COUNTRIES } from 'lib/constants/localisation';

export const isTaxIncludedCountry = (countryCode: string) =>
  TAX_INCLUDED_COUNTRIES.includes(countryCode);
